import AGRICULTURE_IMG from 'ui/images/industry/agriculture_forestry_fishing.jpeg';
import REAL_ESTATE_IMG from 'ui/images/industry/real_estate.jpeg';
import ELECTRONIC_DEVICE_IMG from 'ui/images/industry/electronic.jpeg';
import ACCOMMODATION_FOOD_SERVICE_IMG from 'ui/images/industry/lodging_food_services.jpeg';
import EDUCATION_SERVICE_IMG from 'ui/images/industry/education_related_services.jpeg';
import FURNITURE_EQUIPMENT_IMG from 'ui/images/industry/furniture_and_equipment_manufacturing.jpeg';
import MINING_QUARRYING_IMG from 'ui/images/industry/kogyo.jpeg';
import CONSTRUCTION_IMG from 'ui/images/industry/construction.jpeg';
import FOOD_BEVERAGE_TOBACCO_IMG from 'ui/images/industry/food_beverage_tobacco_manufacturing.jpeg';
import FIBER_IMG from 'ui/images/industry/fiber.jpeg';
import WOOD_PULP_PAPER_IMG from 'ui/images/industry/wood_pulp_paper_manufacturing.jpeg';
import CHEMICAL_IMG from 'ui/images/industry/chemical.jpeg';
import PETROLEUM_COAL_PRODUCT_IMG from 'ui/images/industry/petroleum_coal_product_manufacturing.jpeg';
import SOIL_AND_STONE_PRODUCT_IMG from 'ui/images/industry/soil_and_stone_product_manufacturing.jpeg';
import STEEL_IMG from 'ui/images/industry/steel.jpeg';
import NON_FERROUS_METAL_IMG from 'ui/images/industry/manufacturing_industry.jpeg';
import METAL_PRODUCT_IMG from 'ui/images/industry/metal_product.jpeg';
import GENERAL_MACHINERY_EQUIPMENT_IMG from 'ui/images/industry/general_purpose_machinery.jpeg';
import PRODUCTION_MACHINERY_IMG from 'ui/images/industry/production_machinery.jpeg';
import FACTORY_IMG from 'ui/images/industry/factory.jpeg';
import ELECTRICAL_MACHINERY_IMG from 'ui/images/industry/electrical_machinery.jpeg';
import TELECOMMUNICATIONS_MACHINERY_IMG from 'ui/images/industry/telecommunications_machinery.jpeg';
import TRANSPORTATION_MACHINERY_IMG from 'ui/images/industry/airplane.jpeg';
import PRINTING_BUSINESS_IMG from 'ui/images/industry/printer.jpeg';
import PLASTIC_PRODUCT_IMG from 'ui/images/industry/plastic_product.jpeg';
import RUBBER_PRODUCT_IMG from 'ui/images/industry/rubber_product.jpeg';
import LEATHER_PRODUCT_IMG from 'ui/images/industry/leather_goods.jpeg';
import OTHER_MANUFACTURING_IMG from 'ui/images/industry/manufacturing_industry.jpeg';
import INFRASTRUCTURE_IMG from 'ui/images/industry/infrastructure.jpeg';
import TELECOMMUNICATIONS_IMG from 'ui/images/industry/telecommunications.jpeg';
import TRANSPORTATION_IMG from 'ui/images/industry/transportation.jpeg';
import WHOLESALE_IMG from 'ui/images/industry/wholesale.jpeg';
import RETAIL_IMG from 'ui/images/industry/retail.jpeg';
import FINANCIAL_INSURANCE_IMG from 'ui/images/industry/financial_insurance.jpeg';
import RENTAL_INDUSTRY_IMG from 'ui/images/industry/rental_car.jpeg';
import SERVICE_INDUSTRY_IMG from 'ui/images/industry/service.jpeg';
import { IPublicSupportUser } from 'domain/entities/SupportUser/SupportUser';

export interface ICompany {
    id: number;
    name: string;
    company_code: string | null;
    area: string;
    prefecture: string;
    number_of_employees: string;
    revenue_scale: string;
    industry: string;
    icon_image: string | null;
    business_description: string;
    question: string;
    hp_url: string | null;
    profit_level: string;
    net_assets_level: string;
    label: string | null;
    unpublished: boolean;
    subsidy_info_requested?: boolean;
    fee_structure: boolean;
    timing_considerations: boolean;
    matching_potential: boolean;
    case_studies: boolean;
    process_flow: boolean;
    fee_structure_txt: string;
    case_studies_txt: string;
    timing_considerations_txt: string;
    matching_potential_txt: string;
    process_flow_txt: string;
    is_sole_proprietor: boolean;
    created_at: string;
    supporter_user?: IPublicSupportUser | null;
}

export interface IPublicCompany {
    id: number;
    industry: string;
    area: string;
    area_name: string;
    prefecture: string;
    prefecture_name: string;
    number_of_employees: string;
    revenue_scale: string;
    question: string | null;
    business_description: string;
    profit_level: string;
    net_assets_level: string;
    match_status?: string | null;
    label: string | null;
    fee_structure: boolean;
    timing_considerations: boolean;
    matching_potential: boolean;
    case_studies: boolean;
    process_flow: boolean;
    fee_structure_txt: string;
    timing_considerations_txt: string;
    matching_potential_txt: string;
    is_sole_proprietor: boolean;
    case_studies_txt: string;
    process_flow_txt: string;
    created_at: string;
    updated_at: string;
}

export const industryMapping = {
    AGRICULTURE: '農業・林業・漁業',
    REAL_ESTATE: '不動産業',
    ELECTRONIC_DEVICE: '情報通信機械器具・電子部品・デバイス',
    ACCOMMODATION_FOOD_SERVICE: '宿泊・飲食サービス業',
    EDUCATION_SERVICE: '教育関連サービス業',
    FURNITURE_EQUIPMENT: '家具・装備品製造業',
    MINING_QUARRYING: '鉱業・採石業・砂利採取業',
    CONSTRUCTION: '建設業',
    FOOD_BEVERAGE_TOBACCO: '食料品・飲料・たばこ・飼料製造',
    FIBER: '繊維',
    WOOD_PULP_PAPER: '木材・木製品・パルプ・紙・紙加工品製造業',
    CHEMICAL_INDUSTRY: '化学工業',
    PETROLEUM_COAL_PRODUCT: '石油製品・石炭製品製造',
    SOIL_AND_STONE_PRODUCT: '窯業・土石製品製造',
    STEEL: '鉄鋼業',
    NON_FERROUS_METAL: '非鉄金属製造',
    METAL_PRODUCT: '金属製品製造',
    GENERAL_MACHINERY_EQUIPMENT: 'はん用機械器具製造',
    PRODUCTION_MACHINERY: '生産用機械器具製造',
    COMMERCIAL_MACHINERY: '業務用機械器具製造',
    ELECTRICAL_MACHINERY: '電気機械器具製造',
    TELECOMMUNICATIONS_MACHINERY: '情報通信機械器具・電子部品・デバイス回路・電子回路製造',
    TRANSPORTATION_MACHINERY: '輸送機械器具製造',
    PRINTING_BUSINESS: '印刷・同関連製造業',
    PLASTIC_PRODUCT: 'プラスチック製品製造',
    RUBBER_PRODUCT: 'ゴム製品製造',
    LEATHER_PRODUCT: '革・同製品製造業',
    OTHER_MANUFACTURING: 'その他の製造業',
    INFRASTRUCTURE: '電気・ガス・熱共有・水道業',
    TELECOMMUNICATIONS: '情報通信業',
    TRANSPORTATION: '運輸業',
    WHOLESALE: '卸売業',
    RETAIL: '小売業',
    FINANCIAL_INSURANCE: '金融業・保険業',
    RENTAL_INDUSTRY: 'レンタル業',
    SERVICE_INDUSTRY: 'サービス業',
};
export function getKeyByValue(obj: { [s: string]: unknown } | ArrayLike<unknown>, value: unknown) {
    return Object.entries(obj).find(([key, val]) => val === value)?.[0];
}

// 業種に対する画像のマッピング
export const industryImageMapping = {
    AGRICULTURE: AGRICULTURE_IMG,
    REAL_ESTATE: REAL_ESTATE_IMG,
    ELECTRONIC_DEVICE: ELECTRONIC_DEVICE_IMG,
    ACCOMMODATION_FOOD_SERVICE: ACCOMMODATION_FOOD_SERVICE_IMG,
    EDUCATION_SERVICE: EDUCATION_SERVICE_IMG,
    FURNITURE_EQUIPMENT: FURNITURE_EQUIPMENT_IMG,
    MINING_QUARRYING: MINING_QUARRYING_IMG,
    CONSTRUCTION_IMG: CONSTRUCTION_IMG,
    FOOD_BEVERAGE_TOBACCO: FOOD_BEVERAGE_TOBACCO_IMG,
    FIBER: FIBER_IMG,
    WOOD_PULP_PAPER: WOOD_PULP_PAPER_IMG,
    CHEMICAL: CHEMICAL_IMG,
    PETROLEUM_COAL_PRODUCT: PETROLEUM_COAL_PRODUCT_IMG,
    SOIL_AND_STONE_PRODUCT: SOIL_AND_STONE_PRODUCT_IMG,
    STEEL: STEEL_IMG,
    NON_FERROUS_METAL: NON_FERROUS_METAL_IMG,
    METAL_PRODUCT: METAL_PRODUCT_IMG,
    GENERAL_MACHINERY_EQUIPMENT: GENERAL_MACHINERY_EQUIPMENT_IMG,
    PRODUCTION_MACHINERY: PRODUCTION_MACHINERY_IMG,
    COMMERCIAL_MACHINERY: FACTORY_IMG,
    ELECTRICAL_MACHINERY: ELECTRICAL_MACHINERY_IMG,
    TELECOMMUNICATIONS_MACHINERY: TELECOMMUNICATIONS_MACHINERY_IMG,
    TRANSPORTATION_MACHINERY: TRANSPORTATION_MACHINERY_IMG,
    PRINTING_BUSINESS: PRINTING_BUSINESS_IMG,
    PLASTIC_PRODUCT: PLASTIC_PRODUCT_IMG,
    RUBBER_PRODUCT: RUBBER_PRODUCT_IMG,
    LEATHER_PRODUCT: LEATHER_PRODUCT_IMG,
    OTHER_MANUFACTURING: OTHER_MANUFACTURING_IMG,
    INFRASTRUCTURE: INFRASTRUCTURE_IMG,
    TELECOMMUNICATIONS: TELECOMMUNICATIONS_IMG,
    TRANSPORTATION: TRANSPORTATION_IMG,
    WHOLESALE: WHOLESALE_IMG,
    RETAIL: RETAIL_IMG,
    FINANCIAL_INSURANCE: FINANCIAL_INSURANCE_IMG,
    RENTAL_INDUSTRY: RENTAL_INDUSTRY_IMG,
    SERVICE_INDUSTRY: SERVICE_INDUSTRY_IMG,
};
